import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const SuccessionPlanningWelcome = ({ onStartClick }) => {
  const handleClick = () => {
    if (typeof onStartClick === 'function') {
      onStartClick();
    }
  };

  return (
    <div className="min-h-screen bg-succession-bg-secondary transition-colors duration-300">
      <div className="max-w-3xl mx-auto pt-16 px-4 sm:px-6 lg:px-8">
        <div className="bg-succession-bg-primary rounded-lg p-8 border border-succession-border shadow-succession-lg transition-colors duration-300">
          <div className="flex items-center justify-center mb-6">
            <DocumentTextIcon className="h-12 w-12 text-succession-primary transition-colors duration-300" />
          </div>
          
          <h1 className="text-2xl font-bold text-center mb-6 text-succession-text-primary transition-colors duration-300">
            Succession Planning Questionnaire
          </h1>
          
          <div className="prose prose-lg mx-auto mb-8">
            <p className="mb-4 text-succession-text-secondary transition-colors duration-300">
              Welcome to your Succession Planning Questionnaire. This comprehensive assessment will help you evaluate 
              your readiness for succession and develop a roadmap for a successful transition.
            </p>
            
            <p className="mb-4 text-succession-text-secondary transition-colors duration-300">
              The questionnaire covers key areas including your personal and business goals, current status of 
              succession planning, emotional and financial readiness, business valuation, and more.
            </p>
            
            <p className="mb-4 text-succession-text-secondary transition-colors duration-300">
              Once completed, you'll receive personalized insights including your emotional readiness score, 
              financial readiness score, and specific recommendations to help you prepare for a successful 
              transition.
            </p>
          </div>
          
          <div className="text-center">
            <button
              onClick={handleClick}
              className="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-succession-primary border border-transparent rounded-md shadow-sm hover:bg-succession-primary-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-succession-primary transition-all duration-300"
            >
              Start Planning
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessionPlanningWelcome; 